module.exports = __webpack_public_path__ + "static/media/alvestakommun.c3ae0d62.png";